module.exports = __webpack_public_path__ + "img/salvar-white.3873d47b.svg";